import axios from "axios";
import { refreshPage } from "./Utils/Common";
import { toast } from "react-toastify";


// const userKey = localStorage.getItem("user-key");

// Set up a global response interceptor
// axios.interceptors.response.use(
//   (response) => {
//     return response;
//   },
//   async (error) => {
//     // Handle 401 error
//     if (error.response && error.response.status === 401) {
//       localStorage.clear();
//       toast.error("Unauthorized. Logging you out...", { autoClose: 5000 });
//       setTimeout(() => {
//         refreshPage();
//         window.location.href = "/";
//       }, 1000);
//     }

//     // Propagate the error to the calling code
//     return Promise.reject(error);
//   }
// );

let config = {
    headers: {
        "api-key" : process.env.REACT_APP_API_KEY,
        "Content-Type": "application/json",
    }
}
let configForm = {
    headers: {
        "api-key" : process.env.REACT_APP_API_KEY,
        "Content-Type": "multipart/form-data",
    }
}



// API Axios Get Call.
export const getAPICall = (url,data) => {
  return axios.get(url, data, config);
};

export const getAPICallWithParams = (url, data) => {
    return axios.get(url, { headers: config.headers, params: data });
}

export const getAPICallWithParamsGoogle = (url) => {
    return axios.get(url);
}

// API Axios Post Call.
export const postAPICall = (url, data) => {
  return axios.post(url, data, config);
};

// API Axios Post Call with File Config
export const postAPICallwithFile = (url, data) => {
    return axios.post(url, data, configForm);
};

// API Axios Post Call.
export const postAPICallCustom = (url, data, customConfig) => {
  return axios.post(url, data, customConfig);
};

// API Axios Put Call.
export const putAPICall = (url, data) => {
  return axios.put(url, data, config);
};
// API Axios Delete Call.
export const deleteAPICall = (url) => {
  return axios.delete(url, config);
};


